import { useEffect, useState } from 'react';
import { NewsItem } from '../../../types/news';

export default function News() {
  const [news, setNews] = useState<NewsItem[]>([]);

  useEffect(() => {
    // localStorage에서 뉴스 데이터 가져오기
    const savedNews = localStorage.getItem('news');
    if (savedNews) {
      const newsItems: NewsItem[] = JSON.parse(savedNews);
      setNews(newsItems.slice(0, 3)); // 최신 3개만
    }
  }, []);

  const displayNews = news.slice(0, 3);

  const getCategoryColor = (category: string) => {
    const colors: Record<string, string> = {
      press: 'text-teal-600',
      blog: 'text-orange-600',
      company: 'text-green-600'
    };
    return colors[category] || 'text-gray-600';
  };

  const getCategoryName = (category: string) => {
    const categories: Record<string, string> = {
      press: 'Press',
      blog: 'Blog',
      company: 'Company'
    };
    return categories[category] || category;
  };

  return (
    <section className="py-24 bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-6">
        <div className="flex justify-between items-end mb-10">
          <h2 className="text-3xl font-bold text-primary">KR Insights</h2>
          <a 
            href="/news" 
            className="text-sm font-bold text-gray-500 hover:text-primary transition cursor-pointer whitespace-nowrap"
          >
            View All
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {displayNews.length > 0 ? (
            displayNews.map((item) => (
              <a
                key={item.id}
                href="/news"
                className="bg-white rounded-lg shadow-sm hover:shadow-lg transition cursor-pointer overflow-hidden group"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <span className={`text-xs font-bold mb-2 block ${getCategoryColor(item.category)}`}>
                    {getCategoryName(item.category)}
                  </span>
                  <h3 className="font-bold text-lg mb-3 text-primary line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-500 text-sm line-clamp-2 mb-3">
                    {item.summary}
                  </p>
                  <p className="text-xs text-gray-400">{item.date}</p>
                </div>
              </a>
            ))
          ) : (
            <div className="col-span-3 text-center py-12">
              <p className="text-gray-500">등록된 뉴스가 없습니다.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
